(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["apella-account-entry"] && !Shopify.designMode) return;
  try {
    (() => {
    const updateAccountFocus = (keyboard) => {
      document.querySelectorAll('shopify-account.apella-account-entry__sheet').forEach((account) => {
        account.toggleAttribute('data-keyboard-focus', keyboard);
      });
    };

    document.addEventListener('pointerdown', () => updateAccountFocus(false), { capture: true, passive: true });
    document.addEventListener('keydown', (event) => {
      if (['Tab', 'Enter', ' ', 'Escape', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        updateAccountFocus(true);
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
